import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xl-12 col-lg-12" }
const _hoisted_3 = { class: "card shadow mb-4" }
const _hoisted_4 = { class: "card-header py-3 d-flex flex-row align-items-center justify-content-start" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fas fa-arrow-circle-left" }, null, -1)
const _hoisted_6 = { class: "m-0 font-weight-bold" }
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (_ctx.allowBack)
            ? (_openBlock(), _createBlock("a", {
                key: 0,
                href: "#",
                class: "text-dark mr-2",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"]))
              }, [
                _hoisted_5
              ]))
            : _createCommentVNode("", true),
          _createVNode("h6", _hoisted_6, _toDisplayString(_ctx.title), 1),
          _createVNode("small", _hoisted_7, _toDisplayString(_ctx.subtitle), 1)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ])
    ])
  ]))
}